module.exports = __webpack_public_path__ + "static/media/foodprint_app1_preview.c5e78f2c.jpg";